module.exports = __webpack_public_path__ + "images/stickers/taco-active.e027fa08f49b43a503a1.png";